import { render } from "./InterviewFlipCard.vue?vue&type=template&id=e2f1d322&scoped=true"
import script from "./InterviewFlipCard.vue?vue&type=script&lang=js"
export * from "./InterviewFlipCard.vue?vue&type=script&lang=js"

import "./InterviewFlipCard.vue?vue&type=style&index=0&id=e2f1d322&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2f1d322"]])

export default __exports__